import { useQuery } from '@tanstack/react-query';

import { apiClient } from '../api-client.ts';
import type { UserDto } from '../types';

export const useAuth = (enabled?: boolean) => {
  return useQuery<UserDto>({
    queryKey: ['user'],
    queryFn: () => apiClient.get('/v1/auth'),
    retry: false,
    enabled,
  });
};
